import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import {
    ThemeProvider as MaterialThemeProvider,
    createTheme as materialCreateTheme,
    THEME_ID as MATERIAL_THEME_ID,
} from '@mui/material/styles';
import { CssVarsProvider } from '@mui/joy/styles';
import CssBaseline from '@mui/joy/CssBaseline';
import { theme } from './theme/theme';
import './index.css';
import Navigator from './components/Navigator'
import Home from './pages/Home';
import NotFound from './pages/NotFound'
import Join from './pages/Join';
import ScrollToTop from './components/ScrollToTop';
import Beliefs from './pages/whoweare/Beliefs';
import Leaders from './pages/whoweare/Leaders';
import Ministries from './pages/grow/Ministries';
import Sermons from './pages/Sermons'
import About from './pages/About';
import Contact from './pages/Contact';

// MUI Material components used in the app (Drawer/IconButton in Navigator,
// Accordion in Join) read a Material theme (theme.typography.pxToRem,
// theme.transitions.*). Joy's theme doesn't provide those, so without a
// Material theme in context every Material component throws and the app renders
// blank. Provide a default Material theme keyed by THEME_ID alongside the Joy
// theme, the supported Material + Joy integration. The shallow theme merge
// preserves the Material theme (under its symbol key) while Joy components keep
// reading the Joy theme.
const materialTheme = materialCreateTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <MaterialThemeProvider theme={{ [MATERIAL_THEME_ID]: materialTheme }}>
    <CssVarsProvider theme={theme} defaultMode="light">
        <CssBaseline />
        <BrowserRouter>
        <ScrollToTop/>
            <Routes>
                <Route path="/" element={<Navigator/>}>
                    <Route index element={<Home/>}/>
                    <Route path='join' element={<Join/>}/>
                    <Route path='leaders' element={<Leaders/>}/>
                    <Route path='beliefs' element={<Beliefs/>}/>
                    <Route path='ministries' element={<Ministries/>}/>
                    <Route path='sermons' element={<Sermons/>}/>
                    <Route path='about' element={<About/>}/>
                    <Route path='contact' element={<Contact/>}/>
                    <Route path="*" element={<NotFound/>}/>
                </Route>
            </Routes>
        </BrowserRouter>
    </CssVarsProvider>
    </MaterialThemeProvider>
);
